// Explicit synthetic preview data. Never used as component defaults.

export const FIXTURE_PACKS = [
  { id: 'age-5-7', title: 'Age 5–7', questCount: 6, valueLabel: '$0.25–$0.50', iconCount: 3 },
  { id: 'age-8-11', title: 'Age 8–11', questCount: 6, valueLabel: '$0.50–$1.00', iconCount: 3 },
  { id: 'weekend-reset', title: 'Weekend reset', questCount: 4, valueLabel: 'Sat–Sun', iconCount: 3 },
  { id: 'pet-care', title: 'Pet care', questCount: 3, valueLabel: 'daily', iconCount: 3 },
];

export const FIXTURE_PACK_DETAILS = {
  'age-8-11': {
    title: 'Age 8–11',
    countLabel: '6 quests',
    note: 'Values are starting points for ages 8–11 — each quest is editable after adding.',
    templates: [
      { id: 'dishwasher', name: 'Unload the dishwasher', value: '$0.75 suggested', icon: 'dishes' },
      { id: 'trash', name: 'Take out the trash', value: '$0.50 suggested', icon: 'trash' },
      { id: 'dog', name: 'Walk the dog', value: '$1.00 suggested', icon: 'dog' },
      { id: 'laundry', name: 'Fold the laundry', value: '$0.75 suggested', icon: 'laundry' },
      { id: 'homework', name: 'Homework session', value: '$1.00 suggested', icon: 'homework' },
      { id: 'plant', name: 'Water the plants', value: '$0.50 suggested', icon: 'plant' },
    ],
  },
};

export const FIXTURE_KIDS = [
  { id: 'maya', name: 'Maya', age: 9, tone: 'lantern' },
  { id: 'leo', name: 'Leo', age: 11, tone: 'river' },
  { id: 'finn', name: 'Finn', age: 6, tone: 'violet' },
];

export const FIXTURE_PREVIEW = [
  { id: 'fri12', date: 'Fri 12', kidId: 'maya' },
  { id: 'sat13', date: 'Sat 13', skipped: true },
  { id: 'sun14', date: 'Sun 14', skipped: true },
  { id: 'mon15', date: 'Mon 15', kidId: 'leo' },
  { id: 'tue16', date: 'Tue 16', kidId: 'finn' },
  { id: 'wed17', date: 'Wed 17', kidId: 'maya' },
  { id: 'thu18', date: 'Thu 18', kidId: 'leo' },
];

export const FIXTURE_BOARD = {
  rangeLabel: 'Mon Jun 8 – Sun Jun 14',
  columns: [
    {
      id: 'mon', day: 'Mon', date: '8', full: 'Monday',
      tiles: [
        { id: 'mon-1', title: 'Dishwasher', icon: 'dishes', assignee: 'Finn' },
        { id: 'mon-2', title: 'Walk Biscuit', icon: 'dog', assignee: 'Leo' },
        { id: 'mon-3', title: 'Homework', icon: 'homework', assignee: 'Maya' },
      ],
    },
    {
      id: 'tue', day: 'Tue', date: '9', full: 'Tuesday',
      tiles: [
        { id: 'tue-1', title: 'Dishwasher', icon: 'dishes', assignee: 'Maya' },
        { id: 'tue-2', title: 'Trash out', icon: 'trash', assignee: 'Leo' },
        { id: 'tue-3', title: 'Make bed', icon: 'bed', assignee: 'Finn' },
      ],
    },
    {
      id: 'wed', day: 'Wed', date: '10', full: 'Wednesday',
      tiles: [
        { id: 'wed-1', title: 'Dishwasher', icon: 'dishes', assignee: 'Leo' },
        { id: 'wed-2', title: 'Water plants', icon: 'plant', assignee: 'Finn' },
        { id: 'wed-3', title: 'Walk Biscuit', icon: 'dog', assignee: 'Leo' },
      ],
    },
    {
      id: 'thu', day: 'Thu', date: '11', full: 'Thursday',
      tiles: [
        { id: 'thu-1', title: 'Dishwasher', icon: 'dishes', assignee: 'Finn' },
        { id: 'thu-2', title: 'Homework', icon: 'homework', assignee: 'Leo' },
        { id: 'thu-3', title: 'Make bed', icon: 'bed', assignee: 'Finn' },
      ],
    },
    {
      id: 'fri', day: 'Fri · today', date: '12', full: 'Friday — today', today: true,
      tiles: [
        { id: 'fri-1', title: 'Dishwasher', icon: 'dishes', assignee: 'Maya' },
        { id: 'fri-2', title: 'Trash out', icon: 'trash', assignee: 'Leo' },
        { id: 'fri-3', title: 'Walk Biscuit', icon: 'dog', assignee: 'Leo' },
      ],
    },
    {
      id: 'sat', day: 'Sat', date: '13', full: 'Saturday',
      tiles: [
        { id: 'sat-1', title: 'Fold laundry', icon: 'laundry', assignee: 'Maya' },
        { id: 'sat-2', title: 'Sweep porch', icon: 'broom', assignee: 'Finn', dragging: true },
      ],
      dropSlot: true,
    },
    {
      id: 'sun', day: 'Sun', date: '14', full: 'Sunday',
      tiles: [
        { id: 'sun-1', title: 'Water plants', icon: 'plant', assignee: 'Finn' },
        { id: 'sun-2', title: 'Walk Biscuit', icon: 'dog', assignee: 'Maya' },
      ],
    },
  ],
};

export const questStudioFixture = {
  packs: FIXTURE_PACKS,
  packDetails: FIXTURE_PACK_DETAILS,
  kids: FIXTURE_KIDS,
  preview: FIXTURE_PREVIEW,
  board: FIXTURE_BOARD,
  profileName: 'Sara',
  avatarAlt: 'Sara — switch profile or preview kid mode',
  notifications: 3,
  defaultQuestName: 'Unload the dishwasher',
  defaultReward: 0.75,
  defaultAssignedKids: ['maya'],
  savedLabel: 'saved 2 min ago',
  lastEditedLabel: 'Last edited by Sara · Fri 6:18 PM',
  nextDueLabel: "Mon Jun 15 (Leo's turn)",
  defaultExpandedPackId: 'age-8-11',
};
